import reduceReducers from 'reduce-reducers'
import createFetchModule from '@utils/store/createFetchModule'
import { FetchActionsWith } from '@typings/generic'
import createFetchSubmodule from '@utils/store/createFetchSubmodule'

export const moduleName = 'reservationInternalStockChangesGrid'

const fetchModule = createFetchModule('@store/ReservationInternalStockChangesGrid', 'LOAD', moduleName)
const exportReservationsOnInternalStockChangesSubmodule = createFetchSubmodule(
  '@store/ReservationInternalStockChangesGrid',
  'EXPORT',
  moduleName,
)

export const actionTypes = {
  ...fetchModule.actionTypes,
  exportReservations: exportReservationsOnInternalStockChangesSubmodule.actionTypes,
}

export default reduceReducers(fetchModule.reducer)

export const actions: FetchActionsWith<typeof actionTypes> = {
  ...fetchModule.actions,
  exportReservations: exportReservationsOnInternalStockChangesSubmodule.actions.run,
}

export const selectors: Selectors = {
  ...fetchModule.selectors,
}
